import {
    Description,
    Title,
    UnavailableButton,
    UnavailableWrapper,
} from './Unavailable.styled';

interface UnavailableProps {
    buttonOnPress: () => void;
    buttonText: string;
    description: string;
    title: string;
}

export const Unavailable = ({
    buttonOnPress,
    buttonText,
    description,
    title,
}: UnavailableProps) => {
    return (
        <UnavailableWrapper>
            <Title>{title}</Title>
            <Description>{description}</Description>
            <UnavailableButton
                onClick={buttonOnPress}
                testId="button_unavailable"
                variant={'primary'}
            >
                {buttonText}
            </UnavailableButton>
        </UnavailableWrapper>
    );
};
